import { NormasTeachingCouponDTO } from "../../ProductService/NormasTeachingCoupon/useNormasTeachingCouponById.ts";

const COPY_SUFFIX = "-COPIA";

/**
 * Suggests the code for a coupon being duplicated: the source code with a
 * "-COPIA" suffix, numbered when that one is already taken. Coupon codes must
 * be unique, so the form starts from a free one; the admin can still change it
 * before creating the coupon.
 */
export function buildDuplicateCouponCode(
  couponCode: string,
  existingCoupons: NormasTeachingCouponDTO[],
): string {
  const takenCodes = new Set(
    existingCoupons.map((coupon) => coupon.couponCode.toUpperCase()),
  );
  const base = `${couponCode.toUpperCase()}${COPY_SUFFIX}`;

  if (!takenCodes.has(base)) return base;

  let attempt = 2;
  while (takenCodes.has(`${base}-${attempt}`)) attempt++;
  return `${base}-${attempt}`;
}
